<p-fieldset styleClass="mt-2">
    <ng-template pTemplate="header">
        <div class="d-flex">
            <fa-icon [icon]='["far","balance-scale"]'></fa-icon>
            <div class="mx-2">
                Legal Stuff
            </div>
            <fa-icon [icon]='["far","check-double"]' *ngIf="sectionComplete"></fa-icon>
            <div class="ms-auto">
                <fa-icon [icon]='["far","question-circle"]' (click)="displayModal.emit('legal')"></fa-icon>
            </div>
        </div>
    </ng-template>
    <div class="d-flex flex-wrap">
        <div class="mt-2 mx-2 flex-fill ">
            <mat-form-field class="w-100">
                <mat-label>Legal Business Name</mat-label>
                <input matInput (change)="inputAction($event)" #legalBusinessName type="text" name="legalBusinessName" [formControl]="legalBusinessNameControl"
                    [(ngModel)]="application.legalBusinessName" />
                <mat-error *ngIf="legalBusinessNameControl.errors">
                    <div *ngIf="legalBusinessNameControl.hasError('required')">Legal business name is required</div>
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <mat-checkbox class="mx-2" name="applicationAddressLegalDifferentFromBusiness"
        (change)="enableLegalAddress($event); inputAction($event); "
        [(ngModel)]="applicationAddressLegalDifferentFromBusiness">
        Different legal address
    </mat-checkbox>

    <div class="d-flex flex-wrap">
        <div class="mt-2 mx-2 flex-fill">
            <mat-form-field class="w-100">
                <mat-label>Legal Street Address</mat-label>
                <input matInput (change)="inputAction($event)" #legalStreet type="text" name="legalStreet"
                    [formControl]="legalAddressStreetControl" [(ngModel)]="application.legalAddress.street" />
                <mat-error *ngIf="legalAddressStreetControl.errors">
                    <div *ngIf="legalAddressStreetControl.hasError('required')">Legal street address is required.</div>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>Suite/Unit</mat-label>
                <input matInput (change)="inputAction($event)" #legalStreet2 type="text" name="legalStreet2" [formControl]="legalAddressStreet2Control"
                    [(ngModel)]="application.legalAddress.street2" />
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>City</mat-label>
                <input matInput (change)="inputAction($event)" #legalCity type="text" name="legalCity"
                    [formControl]="legalAddressCityControl" [(ngModel)]="application.legalAddress.city" />
                <mat-error *ngIf="legalAddressCityControl.errors">
                    <div *ngIf="legalAddressCityControl.hasError('required')">Legal city is required.</div>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">
            <mat-form-field class="w-100">
                <mat-label>State</mat-label>
                <mat-select #legalState (valueChange)="inputAction($event)" name="legalState"
                    [formControl]="legalAddressStateControl" [(ngModel)]="application.legalAddress.state">
                    <mat-option *ngFor="let value of app.references.states" [value]="value.value">
                        {{value.label}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="legalAddressStateControl.errors">
                    <div *ngIf="legalAddressStateControl.hasError('required')">Legal state is required.</div>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>Zip Code</mat-label>
                <input matInput #legalPostalCode (change)="inputAction($event)" #physicalPostalCode type="text"
                    name="legalPostalCode" [formControl]="legalAddressPostalCodeControl"
                    [(ngModel)]="application.legalAddress.postalCode" />
                <mat-error *ngIf="legalAddressPostalCodeControl.errors">
                    <div *ngIf="legalAddressPostalCodeControl.hasError('required')">Legal postal code is required.</div>
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="d-flex flex-wrap">
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>Tax ID / EIN</mat-label>
                <input matInput (change)="inputAction(taxIdControl)" #legalTaxId type="text" name="legalTaxId"
                    [(ngModel)]="application.taxId" [formControl]="taxIdControl" [textMask]="{mask: app.references.einMask}" />
                <mat-error *ngIf="taxIdControl.errors">
                    <div *ngIf="taxIdControl.hasError('required')">Tax ID (EIN for business, SSN for sole
                        proprietorship) is required</div>
                    <div *ngIf="taxIdControl.hasError('notANumber')">Tax ID must be numbers only.</div>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2 flex-fill ">
            <mat-form-field class="w-100">
                <mat-label>Business Entity Type</mat-label>
                <mat-select #legalBusinessEntityType (valueChange)="inputAction($event)" name="legalBusinessEntityType"
                    [formControl]="businessEntityControl" [(ngModel)]="application.entityType">
                    <mat-option *ngFor="let value of businessEntityType" [value]="value.value">
                        {{value.label}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="businessEntityControl.errors">
                    <div *ngIf="businessEntityControl.hasError('required')">Please select a business entity type.</div>
                </mat-error>
            </mat-form-field>
        </div>
    </div>
</p-fieldset>